export default "__VITE_ASSET__CrHndgfj__"